export default __webpack_public_path__ + "static/cta-do-069730be8c54aef04000628eb8dace5e.png";